'use client'

import type { ReactNode } from 'react'
import SearchProducts from '../search-products'
import { SearchBar } from './components/SearchBar'
import { useNavbar } from './hooks/useNavbar'

interface SearchContainerProps {
  children: ReactNode
}

export function SearchContainer({ children }: SearchContainerProps) {
  return (
    <div className="flex items-center gap-2 sm:gap-3 md:gap-4">{children}</div>
  )
}

export function SearchProductsWrapper() {
  const { isSearchVisible, termSearch, searchQuery, handleBlur } = useNavbar()

  return (
    <SearchProducts
      isSearchVisible={isSearchVisible}
      onClose={handleBlur}
      searchQuery={searchQuery}
      termSearch={termSearch}
    />
  )
}

export function SearchBarWrapper() {
  const {
    isSearchVisible,
    searchQuery,
    termSearch,
    handleFocus,
    handleRedirectCourse,
    setSearchQuery,
  } = useNavbar()

  return (
    <SearchBar
      isSearchVisible={isSearchVisible}
      onSearchChange={setSearchQuery}
      onSearchFocus={handleFocus}
      onSubmit={handleRedirectCourse}
      searchQuery={searchQuery}
      termSearch={termSearch}
    />
  )
}
